import {defineStore} from 'pinia';
import Client from "../modules/Client";
import {notify} from "@kyvg/vue3-notification";
import User from "../modules/User";

export const NotificationStore = defineStore('notifications', {
    state: () => ({
        notifications: [],
        unread: 0,
        loading: false,
        socket: false,
    }),
    getters: {
        getNotifications: (state) => state.notifications,
        getUnread: (state) => state.unread,
        getLoading: (state) => state.loading,
    },
    actions: {
        setUnread(unread) {
            this.unread = unread;
            this.updateTitle();
        },
        enableSockets() {
            if (!this.socket) {
                this.socket = true;

                // Initialize the Web Audio API context
                const audioContext = new (window.AudioContext || window.webkitAudioContext)();

                // Get the audio element
                const audioElement = document.querySelector('#notifications-audio');

                // Create a MediaElementAudioSourceNode
                const source = audioContext.createMediaElementSource(audioElement);

                // Connect the source to the audio context's destination (the speakers)
                source.connect(audioContext.destination);

                // Function to play the notification sound using Web Audio API
                function playNotificationSound() {
                    // Start playing the audio
                    audioElement.play();
                }

                const user = new User();

                Echo.private('users.' + user.id())
                    .notification((notification) => {
                        if (user.data().settings.notifications?.settings?.sound) {
                            playNotificationSound();
                        }

                        this.fetchNotifications();
                    });
            }
        },
        updateTitle() {
            let value = this.unread;
            let title = document.querySelector('title');
            let string = title.innerText.replace(/^\(\d+\)\s*/i, '');
            let unread = value ? '(' + value + ') ' : '';
            title.innerText = unread + string;
        },
        async fetchNotifications() {
            if (!this.loading) {
                this.loading = true;

                Client.get('/api/v1.1/notifications')
                    .then(response => {
                        this.notifications = response.data.data;

                        let unread = this.notifications.filter(noty => {
                            return noty.read === false;
                        }).length;

                        this.setUnread(unread);
                    })
                    .catch(error => {
                        notify({
                            type: 'error',
                            text: 'Не удалось, сорян',
                        });
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
        }
    },
})
